import React from 'react'
import IconBase from 'react-icon-base'

export default props => (
  <IconBase viewBox="0 0 26.957 26.957" {...props}>
    <path d="M21.8958,22.3162h-6.74V4.6258h6.74Zm-5.0547-1.6855H20.21V6.31H16.8411Z" />
    <polygon points="15.998 22.316 10.102 22.316 10.102 7.995 15.998 7.995 15.998 9.679 11.787 9.679 11.787 20.631 15.998 20.631 15.998 22.316" />
    <polygon points="10.945 22.316 5.047 22.316 5.047 11.365 10.945 11.365 10.945 13.049 6.733 13.049 6.733 20.631 10.945 20.631 10.945 22.316" />
    <polygon points="5.89 22.316 -0.008 22.316 -0.008 14.734 5.89 14.734 5.89 16.419 1.678 16.419 1.678 20.631 5.89 20.631 5.89 22.316" />
    <rect x="23.5794" y="20.6307" width="3.3701" height="1.6855" />
  </IconBase>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Icons/CallAnalytics.jsx